import React, { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import './Home.css';
import withAuth from '../components/withAuth';
import KeystoneMyOpenAppList from '../components/KeystoneMyOpenAppList';

class KeystoneMyOpenHome extends Component {
    render() {

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <KeystoneMyOpenAppList/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser
    };
};
const mapDispatchToProps = () => {
    return {
    };
};
export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps)) (KeystoneMyOpenHome);
